import script from "./TopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./TopUp.vue?vue&type=script&setup=true&lang=js"

import "./TopUp.vue?vue&type=style&index=0&id=9007f4a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9007f4a2"]])

export default __exports__